import _ from 'lodash';

const TRUNCATE_LENGTH = 15;
const TRUNCATE_ELLIPSIS = '...';

const truncateText = (text: string, length: number = TRUNCATE_LENGTH): string => {
  if (!text) return '';
  if (text.length <= length) return text;

  const truncatedText = _.truncate(text, {
    length,
    omission: TRUNCATE_ELLIPSIS,
  });

  return truncatedText;
};

export default truncateText;
